export default {
  state: {
    appVersions: [],
    loading: false,
  },
  getters: {
    appVersions: state => state.appVersions,
    loading: state => state.loading,
  },
  mutations: {
    setAppVersions(state, appVersions) {
      state.appVersions = appVersions;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit, dispatch, state }, queryString) {
      commit('setLoading', true);
      try {
        const appVersions = await axios.get('api/app-versions' + (queryString || ''));
        commit('setAppVersions', appVersions);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/app-versions/${id}`);
    },
    async create({ commit }, { data, config }) {
      await axios.post('api/app-versions', data, config);
    },
    async update({ commit }, { data, config }) {
      await axios.put('api/app-versions', data, config);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/app-versions/${id}`);
    },
  },
};
